import styles from './categories.module.scss'
import { Button, H2, IconEdit, IconExpand, SectionContainer } from "@touche-lts/panel-ui/dist"
import { useRootStore } from "mobx-stores/store-provider"
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router'
import { DepartmentCategory } from 'models/departments'

const CategoriesDepartmentPageComponent = () => {

  const {
    departmentsStore: {
      departmentStore,
      openCategory
    },
    routingStore: {
      push
    }
  } = useRootStore(),

    { departmentId } = useParams<{ departmentId: string }>();


  return (
    <SectionContainer
      extraPaddingBottom
    >
      <H2 className='pb-4'>
        Categories
      </H2>
      <Button
        preset='link'
        style={{ marginBottom: 30 }}
        onClick={() => push('/departments/' + departmentId + '/category')}
      >
        <IconExpand style={{ marginRight: 8, fill: styles.primary }} />
        Add{!!departmentStore?.categories?.length && ' another'} category
      </Button>
      {departmentStore?.categories.map((category: DepartmentCategory, categoryIndex: number) => {
        return (
          <div key={categoryIndex} >
            <div onClick={() => openCategory(departmentId, categoryIndex)} className={styles.categoryRow} >
              <h4>{category.name}</h4>
              {/* <IconEdit style={{cursor: 'pointer'}} onClick={() => openCategory(departmentId, categoryIndex)} /> */}
            </div>
            <hr />
          </div>
        )
      })}
    </SectionContainer>
  )
},

  CategoriesDepartmentsPage = observer(CategoriesDepartmentPageComponent)
export { CategoriesDepartmentsPage }
